import { atom } from 'jotai'

/**
 * ドラッグ開始時の元の行（planSlotId）
 * 同じ行内でのドラッグ中は中央スナップをスキップするために使用
 */
export const dragOriginPlanSlotIdAtom = atom<number | null>(null)

dragOriginPlanSlotIdAtom.debugLabel = 'dragOriginPlanSlotIdAtom'

/**
 * ドラッグ開始時の scrollableAncestors の scrollTop 配列
 * 同じ行内ドラッグ中、scroll に追従しつつ元矢羽根の Y 位置を維持するために使用
 */
export const dragOriginScrollTopsAtom = atom<number[] | null>(null)

dragOriginScrollTopsAtom.debugLabel = 'dragOriginScrollTopsAtom'

/**
 * ドラッグ開始元がピン止め行のドッキング表示だったか
 * 同一行判定を本体行と区別するために使用
 */
export const dragOriginPinnedAtom = atom<boolean>(false)

dragOriginPinnedAtom.debugLabel = 'dragOriginPinnedAtom'
